import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';

import { Button, DetailPageLayout } from 'src/components/common';
import { EmployerStaffWrapperCVandPEOStaff } from 'src/components/employer';
import { ModalId } from 'src/constants/modals';
import { useEmployerParamId } from 'src/hooks/employer';
import { useModal } from 'src/hooks/shared';
import { useCurrentUserPermissions } from 'src/hooks/user';
import { EmployerStaffDetailsModal } from 'src/modals/employer';
import { EmployerStaffInviteModal } from 'src/modals/employerStaff';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const EmployerStaffPageCVandPEOStaff = () => {
  const { openModal } = useModal();
  const employerId = useEmployerParamId();
  const { isPeoManager } = useCurrentUserPermissions();

  const onClickModal = React.useCallback(() => {
    openModal(ModalId.EmployerAdminInviteStaffModal, {
      employerId,
    });
  }, [employerId, openModal]);

  return (
    <DetailPageLayout
      titleContent="Staff"
      topRightContent={
        !isPeoManager ? (
          <Button variant="contained" size="small" onClick={onClickModal} startIcon={<AddIcon />}>
            new
          </Button>
        ) : null
      }
    >
      <TableDataProvider>
        <EmployerStaffWrapperCVandPEOStaff employerId={employerId} />
      </TableDataProvider>
      <EmployerStaffDetailsModal />
      <EmployerStaffInviteModal />
    </DetailPageLayout>
  );
};
